'use client';

import { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';

import { Overlay, VideoContainer, CloseButton } from './modal-video.elements';

import { IconX } from '@tabler/icons-react';

const getVideoUrl = (channel, videoId, autoplay) => {
  const autoplayParam = autoplay ? 1 : 0;

  if (channel === 'vimeo') {
    return `https://player.vimeo.com/video/${videoId}?autoplay=${autoplayParam}&title=0&byline=0&portrait=0`;
  }

  if (channel === 'youtube') {
    return `https://www.youtube.com/embed/${videoId}?autoplay=${autoplayParam}&rel=0`;
  }

  return '';
};

const ModalVideoWrapper = ({ channel, videoId, isOpen, onClose, autoplay = true }) => {
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen || !videoId) return null;

  const videoUrl = getVideoUrl(channel, videoId, autoplay);

  return createPortal(
    <>
      <Overlay onClick={onClose} />
      <VideoContainer>
        <iframe
          src={videoUrl}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          title="Video player"
        />
      </VideoContainer>
      <CloseButton onClick={onClose} aria-label="Close video">
        <IconX size={32} />
      </CloseButton>
    </>,
    document.body
  );
};

export { ModalVideoWrapper };
